export default "__VITE_ASSET__CcsErPmn__"